"use client";

import React, { useEffect, useRef, useState } from "react";
import "@google/model-viewer";

interface ModelViewerProps {
  onModelLoaded?: () => void;
}
interface HTMLModelViewerElement extends HTMLElement {
  cameraOrbit?: string;
}

export default function ModelViewer({ onModelLoaded }: ModelViewerProps) {
  const viewerRef = useRef<HTMLModelViewerElement>(null);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const viewer = viewerRef.current;
/*     let angle = 0;
    let direction = 1; */
    let userIsInteracting = false;
    let interval: NodeJS.Timeout;

    const handleModelVisible = () => {
      setTimeout(() => {
        setIsLoaded(true);
        onModelLoaded?.();
      }, 900);
    };

/*     const startAnimation = () => {
      interval = setInterval(() => {
        if (!userIsInteracting && viewer) {
          angle += direction * 0.2;
          if (angle > 10 || angle < -10) direction *= -1;
          viewer.cameraOrbit = `${angle}deg 65deg 2.5m`;
        }
      }, 50);
    }; */

    /* const stopAnimation = () => clearInterval(interval); */

/*     const handleInteraction = () => {
      userIsInteracting = true;
      stopAnimation();
    }; */

    if (viewer) {
      viewer.addEventListener("model-visibility", handleModelVisible);
     /*  viewer.addEventListener("mousedown", handleInteraction);
      viewer.addEventListener("touchstart", handleInteraction);
      viewer.addEventListener("wheel", handleInteraction); */
      /* startAnimation(); */
    }

    return () => {
      /* stopAnimation(); */
      if (viewer) {
        viewer.removeEventListener("model-visibility", handleModelVisible);
        /* viewer.removeEventListener("mousedown", handleInteraction);
        viewer.removeEventListener("touchstart", handleInteraction);
        viewer.removeEventListener("wheel", handleInteraction); */
      }
    };
  }, []);

  return (
    <model-viewer
      className="model-container"
      ref={viewerRef}
      src="/models/logo.glb"
      alt="JS Logo 3D"
      auto-rotate
      camera-controls
      shadow-intensity="2"
      exposure="1"
      disable-zoom
      disable-pan
      disable-tap
      rotation-per-second="3deg"
      interaction-prompt="none"
      camera-orbit="0deg 50deg 1.4m"
      ar
      style={{
        height: "500px",
        background: "transparent",
      }}
    />
  );
}
